import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { debounceTime, Subject } from 'rxjs';
import 'round-slider';
declare let jQuery: any;

@Component({
    selector: 'app-rotator',
    templateUrl: './rotator.component.html',
    styleUrls: ['./rotator.component.scss']
})
export class RotatorComponent implements OnInit, AfterViewInit, OnDestroy {
    
    @Input() set value(_value) {
        if (this.rotatorData) {
            this.rotatorData.setValue(_value);
            this.rotated = _value;
        } else {
            this.rotation = _value || 0;
        }
    }
    @Input() set disabled(_status) {
        this.status = !!_status;
        if (this.rotatorData) {
            if (_status) {
                this.rotatorData.disable();
            } else {
                this.rotatorData.enable();
            }
        }
    }
    @Input() min = 0;
    @Input() max = 359;
    @Input() step = 1;
    @Input() showToolTop = true;

    @Output() changed: EventEmitter<any> = new EventEmitter();

    private subSelection = new Subject<any>();
    private rotatorData;
    private rotation = 0;
    private status = false;
    public rotated = 0;

    constructor() {
        this.subSelection.pipe(
            debounceTime(100)
        ).subscribe(event => {
            this.changed.emit(event);
        });
    }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            jQuery("#rotator").roundSlider({
                radius: 38,
                width: 8,
                min: this.min,
                max: this.max,
                value: this.rotation,
                step: this.step,
                handleSize: "+12",
                handleShape: "dot",
                sliderType: "min-range",
                mouseScrollAction: true,
                editableTooltip: this.showToolTop,
                showTooltip: this.showToolTop,
                disabled: this.status,
                change: (e) => this.changeRotate(e),
            });
            this.rotatorData = jQuery("#rotator").data("roundSlider");
            this.rotated = this.rotation;
        });
    }

    ngOnDestroy() {
        if (this.subSelection) {
            this.subSelection.unsubscribe();
        }
    }

    private changeRotate(e) {
        const value = e.value || 0;
        this.rotated = value;
        this.subSelection.next(value);
    }

}
